export default "__VITE_ASSET__Dt$Y0El3__"